module.exports = __webpack_public_path__ + "img/duy.a46f7a28.jpg";